import Axios from "axios";

// notification-service has its own domain (see its infra/api.ts) rather than
// going through the legacy BFF or bffv2 - this one request is unauthenticated
// by design (see notification-service/infra/api.ts's unsubscribe route),
// reached from an email link with no logged-in session, so it needs its own
// client rather than reusing punctClient's authenticated baseURL.
const notificationClient = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_NOTIFICATION_API_BASE_URL,
});

const notificationApi = {
  subscriptions: {
    unsubscribe: (token: string): Promise<void> =>
      notificationClient
        .post("/subscriptions/unsubscribe", { token })
        .then(() => undefined),
  },
};

export { notificationApi };
